import React, { FC } from "react"
import * as ReactDOM from "react-dom"
import { Node } from "slate"

import { PhotoEditor } from "./components/editor/PhotoEditor"
import { photoEditorInitData } from "./data/photoEditorInitData"

const App: FC<{}> = () => {
  return (
    <PhotoEditor initData={photoEditorInitData.children as Node[]}>
      hi
    </PhotoEditor>
  )
}

function init() {
  // console.log(renderToString(<App />));
  ReactDOM.render(<App />, document.querySelector("#bl-layout-container"))
}

window.addEventListener("load", init)
